import { render, staticRenderFns } from "./AdminMessages.vue?vue&type=template&id=3387eb6d&"
import script from "./AdminMessages.vue?vue&type=script&lang=ts&"
export * from "./AdminMessages.vue?vue&type=script&lang=ts&"
import style0 from "./AdminMessages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports